module.exports = __webpack_public_path__ + "static/media/2019Consumer_Satisfaction_Results.010fb061.pdf";